import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Calculator, FileText, Cog, Wrench } from "lucide-react";
import { useTranslation } from "react-i18next";

const ServicesSection = () => {
  const { t } = useTranslation('services');
  
  const services = [
    {
      icon: Calculator,
      title: t('services.0.title'),
      description: t('services.0.description'),
      popular: t('services.0.popular') === 'true'
    },
    {
      icon: Wrench,
      title: t('services.1.title'),
      description: t('services.1.description'),
      popular: t('services.1.popular') === 'true'
    },
    {
      icon: FileText,
      title: t('services.2.title'),
      description: t('services.2.description'),
      popular: t('services.2.popular') === 'true'
    },
    {
      icon: Cog,
      title: t('services.3.title'),
      description: t('services.3.description'),
      popular: t('services.3.popular') === 'true'
    }
  ];

  return (
    <section id="services" className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <Badge variant="outline" className="mb-4">{t('badge')}</Badge>
          <h2 className="text-4xl font-bold mb-6">{t('title')}</h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            {t('description')}
          </p>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-12">
          {services.map((service, index) => {
            const IconComponent = service.icon;
            return (
              <Card key={index} className="relative hover:shadow-elegant transition-smooth group">
                {service.popular && (
                  <Badge className="absolute -top-3 left-4 bg-accent text-accent-foreground">
                    {t('popularBadge')}
                  </Badge>
                )}
                <CardHeader className="text-center">
                  <div className="flex items-center justify-center w-12 h-12 bg-accent/10 rounded-lg mb-4 mx-auto group-hover:bg-accent group-hover:text-accent-foreground transition-smooth">
                    <IconComponent className="w-6 h-6 text-accent group-hover:text-accent-foreground" />
                  </div>
                  <CardTitle className="text-lg">{service.title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-center">
                    {service.description}
                  </CardDescription>
                </CardContent>
              </Card>
            );
          })}
        </div>
        
        <div className="text-center">
          <Button variant="outline" size="lg">
            {t('button')}
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;